import createVueComponent from '../createVueComponent';

const LampCeiling = createVueComponent('LampCeilingIcon', [
  ['path', { d: 'M12 2v5', key: 'nd4vlx' }],
  ['path', { d: 'M6 7h12l4 9H2l4-9Z', key: '123d64' }],
  ['path', { d: 'M9.17 16a3 3 0 1 0 5.66 0', key: '1061mw' }],
]);

export default LampCeiling;
